<template>
    <div class="index-wrap">
        <van-nav-bar
            title="订单详情"
            left-arrow
            @click-left="$router.back();"
        ></van-nav-bar>
        <view-header :detail="orderDetail"></view-header>
        <view-body :detail="orderDetail"></view-body>
        <view-footer :detail="orderDetail"></view-footer>
        <van-action-sheet v-model="visible" title="订单追踪">
            <div class="follow-wrap">
                <van-steps direction="vertical" :active="0" active-color="#4BA4FB">
                    <van-step v-for="(item, index) in orderFollow" :key="index">
                        <span class="follow-text follow-state">{{ statusFilter(item.orderStatusStatus) }}</span>
                        <span class="follow-text follow-time">{{ item.orderStatusChangeTime }}</span>
                    </van-step>
                </van-steps>
            </div>
        </van-action-sheet>
    </div>
</template>
<script>
import ViewHeader from './ViewHeader';
import ViewBody from './ViewBody';
import ViewFooter from './ViewFooter';
import { mapActions, mapState } from 'vuex';
export default {
    components: {
        ViewHeader,
        ViewBody,
        ViewFooter
    },
    data() {
        return {
            visible: false
        };
    },
    computed: {
        ...mapState('myOrder', {
            orderDetail: 'orderDetail',
            orderFollow: 'orderFollow'
        }),
        status() {
            return this.$store.state.orderStatus;
        }
    },
    methods: {
        ...mapActions('myOrder', {
            getOrderDetail: 'getOrderDetailAction',
            getOrderFollow: 'getOrderFollowAction'
        }),
        statusFilter(value) {
            let row = this.status.find(item => parseInt(item.key) === value);
            return row ? row.value : '';
        }
    },
    created() {
        let id = this.$route.params.id;
        this.getOrderDetail(id);
        this.getOrderFollow(id);
    }
};
</script>
<style lang="scss" scoped>
.index-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.van-nav-bar .van-icon {
    color: #000000;
}
.van-nav-bar__title {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
}
.follow-wrap {
    padding: 10px;

    .follow-state {
        text-align: left;
    }
    .follow-time {
        float: right;
    }
}
</style>